import { useState } from "react";
import { processarPaciente } from "../services/rastreamento.service";

const useProcessarPaciente = ({
	pacienteId,
	onPacienteProcessado,
	onDadosAtualizados,
}) => {
	const [processando, setProcessando] = useState(false);
	const [mensagem, setMensagem] = useState("");

	const limparMensagemComDelay = () => {
		setTimeout(() => setMensagem(""), 3000);
	};

	const handleProcessarPaciente = async () => {
		if (!pacienteId || processando) {
			return;
		}

		try {
			setProcessando(true);
			setMensagem("");

			await processarPaciente(pacienteId);
			setMensagem("Paciente processado com sucesso!");

			await new Promise((resolve) => setTimeout(resolve, 800));

			if (typeof onDadosAtualizados === "function") {
				await onDadosAtualizados();
			}

			if (typeof onPacienteProcessado === "function") {
				onPacienteProcessado();
			}

			limparMensagemComDelay();
		} catch (error) {
			console.error("Erro ao processar paciente:", error);
			setMensagem("Erro ao processar paciente");
			limparMensagemComDelay();
		} finally {
			setProcessando(false);
		}
	};

	return {
		processando,
		mensagem,
		handleProcessarPaciente,
	};
};

export default useProcessarPaciente;
